import React, { useState } from "react";
import {
  FaChevronDown,
  FaChevronUp,
  FaArrowLeft,
} from "react-icons/fa";

const FeeDetailNew = () => {
  const [expandedItems, setExpandedItems] = useState({});

  const toggleExpand = (key) => {
    setExpandedItems((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const installments = [
    {
      id: 1,
      title: "Apr - Jun",
      balance: "12,500",
      dueDate: "2026-04-10",
      months: [
        {
          month: "April",
          fees: [
            { name: "Tuition Fee", amount: "4000" },
            { name: "Transport Fee", amount: "1500" },
          ],
        },
        {
          month: "May",
          fees: [
            { name: "Tuition Fee", amount: "4000" },
            { name: "Activity Fee", amount: "1000" },
          ],
        },
      ],
    },
    {
      id: 2,
      title: "Jul - Sep",
      balance: "15,000",
      dueDate: "2026-07-10",
      months: [
        {
          month: "July",
          fees: [
            { name: "Tuition Fee", amount: "5000" },
            { name: "Transport Fee", amount: "2000" },
          ],
        },
      ],
    },
  ];

  return (
    <div className="page-wrapper">
      <div className="content">
    <div
      style={{
        background: "#f4f7fb",
        minHeight: "100vh",
        padding: "20px",
      }}
    >
      <div
        style={{
          maxWidth: "1100px",
          margin: "auto",
        }}
      >
        {/* Header */}
        <div
          style={{
            background: "#0d6efd",
            borderRadius: "16px",
            padding: "18px 25px",
            color: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "20px",
            boxShadow: "0 4px 14px rgba(0,0,0,0.1)",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "15px",
            }}
          >
            <FaArrowLeft style={{ cursor: "pointer" }} />

            <h3
              style={{
                margin: 0,
                fontWeight: "700",
              }}
            >
              Fee Installment
            </h3>
          </div>

          <button
            style={{
              background: "#fff",
              color: "#0d6efd",
              border: "none",
              padding: "10px 18px",
              borderRadius: "10px",
              fontWeight: "600",
              cursor: "pointer",
            }}
          >
            History
          </button>
        </div>

        {/* Student Info */}
        <div
          style={{
            background: "#fff",
            borderRadius: "16px",
            padding: "25px",
            marginBottom: "25px",
            boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
          }}
        >
          <h4
            style={{
              marginBottom: "20px",
              fontWeight: "700",
              color: "#222",
            }}
          >
            Student Details
          </h4>

          <div className="row">
            <div className="col-md-6 mb-3">
              <label className="fw-bold text-muted">
                Student Name
              </label>

              <div className="mt-1">Rahul Sharma</div>
            </div>

            <div className="col-md-6 mb-3">
              <label className="fw-bold text-muted">
                Admission No.
              </label>

              <div className="mt-1">ADM2026001</div>
            </div>

            <div className="col-md-6 mb-3">
              <label className="fw-bold text-muted">
                Father Name
              </label>

              <div className="mt-1">Rakesh Sharma</div>
            </div>

            <div className="col-md-6 mb-3">
              <label className="fw-bold text-muted">
                Mobile Number
              </label>

              <div className="mt-1">9876543210</div>
            </div>

            <div className="col-md-6 mb-3">
              <label className="fw-bold text-muted">
                Email
              </label>

              <div className="mt-1">
                rahul@gmail.com
              </div>
            </div>

            <div className="col-md-6 mb-3">
              <label className="fw-bold text-muted">
                Class Section
              </label>

              <div className="mt-1">10-A</div>
            </div>
          </div>
        </div>

        {/* Installment Section */}
        <div
          style={{
            background: "#fff",
            borderRadius: "16px",
            padding: "25px",
            boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "20px",
            }}
          >
            <h4
              style={{
                fontWeight: "700",
                margin: 0,
              }}
            >
              Fee Installments
            </h4>
          </div>

          <div className="table-responsive">
            <table className="table align-middle">
              <thead>
                <tr
                  style={{
                    background: "#f7f9fc",
                  }}
                >
                  <th>Installment</th>
                  <th>Total Due</th>
                  <th>Total Paid</th>
                  <th>Balance</th>
                  <th>Due Date</th>
                </tr>
              </thead>

              <tbody>
                {installments.map((item) => (
                  <React.Fragment key={item.id}>
                    <tr
                      style={{
                        borderBottom:
                          "1px solid #f0f0f0",
                      }}
                    >
                      <td>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "12px",
                          }}
                        >
                          <input
                            type="checkbox"
                            style={{
                              width: "18px",
                              height: "18px",
                              cursor: "pointer",
                            }}
                          />

                          <span
                            style={{
                              fontWeight: "600",
                            }}
                          >
                            {item.title}
                          </span>

                          <button
                            onClick={() =>
                              toggleExpand(item.id)
                            }
                            style={{
                              border: "none",
                              background: "#eef4ff",
                              width: "30px",
                              height: "30px",
                              borderRadius: "50%",
                              cursor: "pointer",
                              display: "flex",
                              alignItems: "center",
                              justifyContent:
                                "center",
                            }}
                          >
                            {expandedItems[item.id] ? (
                              <FaChevronUp />
                            ) : (
                              <FaChevronDown />
                            )}
                          </button>
                        </div>
                      </td>

                      <td
                        style={{
                          fontWeight: "600",
                          color: "#198754",
                        }}
                      >
                        ₹ {item.balance}
                      </td>
                      <td
                        style={{
                          fontWeight: "600",
                          color: "#198754",
                        }}
                      >
                        ₹ {item.balance}
                      </td>
                      <td
                        style={{
                          fontWeight: "600",
                          color: "#198754",
                        }}
                      >
                        ₹ {item.balance}
                      </td>

                      <td>{item.dueDate}</td>
                    </tr>

                    {expandedItems[item.id] && (
                      <tr>
                        <td colSpan={3}>
                          <div
                            style={{
                              background: "#f8fafc",
                              borderRadius: "12px",
                              padding: "15px",
                            }}
                          >
                            {item.months.map(
                              (month, index) => (
                                <div
                                  key={index}
                                  style={{
                                    marginBottom:
                                      "18px",
                                  }}
                                >
                                  <div
                                    style={{
                                      background:
                                        "#e9f1ff",
                                      padding:
                                        "10px 14px",
                                      borderRadius:
                                        "8px",
                                      fontWeight:
                                        "700",
                                      marginBottom:
                                        "10px",
                                    }}
                                  >
                                    {month.month}
                                  </div>

                                  {month.fees.map(
                                    (fee, feeIndex) => (
                                      <div
                                        key={feeIndex}
                                        style={{
                                          display:
                                            "flex",
                                          justifyContent:
                                            "space-between",
                                          padding:
                                            "10px 12px",
                                          borderBottom:
                                            "1px solid #eee",
                                        }}
                                      >
                                        <span>
                                          {
                                            fee.name
                                          }
                                        </span>

                                        <span
                                          style={{
                                            fontWeight:
                                              "600",
                                          }}
                                        >
                                          ₹
                                          {
                                            fee.amount
                                          }
                                        </span>
                                      </div>
                                    )
                                  )}
                                </div>
                              )
                            )}
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          </div>

          {/* Buttons */}
          <div
            style={{
              display: "flex",
              gap: "15px",
              marginTop: "30px",
              flexWrap: "wrap",
            }}
          >
            <button
              style={{
                background: "#198754",
                color: "#fff",
                border: "none",
                padding: "12px 30px",
                borderRadius: "10px",
                fontWeight: "600",
                cursor: "pointer",
              }}
            >
              Pay Now
            </button>

            <button
              style={{
                background: "#6c757d",
                color: "#fff",
                border: "none",
                padding: "12px 30px",
                borderRadius: "10px",
                fontWeight: "600",
                cursor: "pointer",
              }}
            >
              Certificate
            </button>
          </div>
        </div>
      </div>
    </div>
    </div>
    </div>
  );
};

export default FeeDetailNew;
